/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-10-08
 * @brief EHP 출동 점검 요청 개발
 *
 ********************************************************************/
import React, { useState } from "react";
//recoil
import { useRecoilValue } from "recoil";
import { loadingBoxState, } from '../../recoil/menuState';
// utils
import clog from "../../utils/logUtils";
import RequestInspection from "./request/RequestInspection";
function ServiceRequestMain(props) {
    //recoil
    const isLoadingBox = useRecoilValue(loadingBoxState);
    //props
    const tabMenuList = props.tabMenuList;
    const curTabMenu = props.curTabMenu;
    const setParentCurTabMenu = props.setCurTabMenu;
    const tabType = props.hasOwnProperty("tabType") ? props.tabType : "main"; //subMain, main //thirdMain 추가
    //const menuItem = props.menuItem
    //const [meun, setMeun] = useState(menuItem)
    const [workMode, setWorkMode] = useState("READ");
    //clog("IN SREVICEREQUEST MAIN : INIT : " + JSON.stringify(tabMenuList));
    clog("IN SREVICEREQUEST MAIN : INIT : " + JSON.stringify(tabType));
    return (React.createElement(React.Fragment, null, (tabType === "main") && React.createElement("main", { className: "container layout-w1 service-page " },
        React.createElement("section", { className: "content " },
            React.createElement("article", { className: `box ${(isLoadingBox) ? "loading__box" : ""}` },
                React.createElement(RequestInspection, { setPopWin: props.setPopWin }))))));
}
export default ServiceRequestMain;
